// extracted by mini-css-extract-plugin
export var arrow = "CollectionInformation-module--arrow--dd846";
export var arrowNo = "CollectionInformation-module--arrow_no--afe82";
export var arrowYes = "CollectionInformation-module--arrow_yes--51cbd";
export var chevronIcon = "CollectionInformation-module--chevronIcon--90047";
export var chevronToggleContainer = "CollectionInformation-module--chevronToggleContainer--21e23";
export var collectionContentContainer = "CollectionInformation-module--collectionContentContainer--0190e";
export var collectionCtaContainer = "CollectionInformation-module--collectionCTAContainer--6c69e";
export var collectionInformation = "CollectionInformation-module--collectionInformation--c5eca";
export var collectionLabel = "CollectionInformation-module--collectionLabel--5c35e";
export var collectionTitle = "CollectionInformation-module--collectionTitle--3fc30";
export var ctaIcon = "CollectionInformation-module--ctaIcon--f0659";
export var download = "CollectionInformation-module--download--f4909";
export var flex = "CollectionInformation-module--flex--68dbb";
export var flex1 = "CollectionInformation-module--flex_1--c4bbf";
export var flexCenter = "CollectionInformation-module--flex_center--8ec0b";
export var flexCenterCol = "CollectionInformation-module--flex_center_col--2d8e1";
export var flexCol = "CollectionInformation-module--flex_col--ff789";
export var flexFixCenterCol = "CollectionInformation-module--flex_fix_center_col--a2444";
export var flexFixedCenterCol = "CollectionInformation-module--flex_fixed_center_col--ff918";
export var fullHeight = "CollectionInformation-module--fullHeight--a5f61";
export var image = "CollectionInformation-module--image--610d4";
export var imageCaption = "CollectionInformation-module--imageCaption--c93bf";
export var imageContainer = "CollectionInformation-module--imageContainer--af126";
export var imageDescription = "CollectionInformation-module--imageDescription--f7d7e";
export var rotating = "CollectionInformation-module--rotating--75181";
export var showMoreMask = "CollectionInformation-module--showMoreMask--1f441";
export var subscribeContainer = "CollectionInformation-module--subscribeContainer--5b648";
export var subscribeText = "CollectionInformation-module--subscribeText--bd86f";
export var toggleShowMoreRow = "CollectionInformation-module--toggleShowMoreRow--78b48";
export var toggleShowMoreText = "CollectionInformation-module--toggleShowMoreText--bcddd";
export var toggleShowMoreTextContainer = "CollectionInformation-module--toggleShowMoreTextContainer--e4e0e";